import { ChatUser, IChatUser } from './chat-user';
import { ChatMessage, IChatMessage } from './chat-message';
import { IUploadFileResult } from '../../../core/interfaces/upload-file-response.interface';

export interface IChatDialog {
  from: IChatUser;
  online: boolean;
  last_message: IChatMessage;
  _id: string;
  important: boolean;
  banned: boolean;
  unread?: number;
  unread_files?: number;
  files?: IUploadFileResult;
}

export class ChatDialog {
  from: ChatUser;
  online: boolean;
  last_message: ChatMessage;
  _id: string;
  selected: boolean;
  important: boolean;
  banned: boolean;
  unread: number;
  unread_files: number;
  files: object;
  fullname: string;

  constructor( data: IChatDialog ) {
    this._id = data._id;
    this.from = new ChatUser(data.from);
    this.online = data.online;
    this.last_message = new ChatMessage(data.last_message);
    this.important = data.important || false;
    this.banned = data.banned || false;
    this.selected = false;
    this.unread = data.unread;
    this.unread_files = data.unread_files;
    this.files = data.files || {};
  }
}



// WEBPACK FOOTER //
// ./app/states/chat/models/chat-dialog.ts